import ErrorRound from '@/components/icons/ErrorRound'
import VerifyRoundIcon from '@/components/icons/VerifyRoundIcon'
import { Slide, ToastContainer } from 'react-toastify'
import { TOAST_CONTAINER_ID, toastVariantClass } from './toastTestHooks'

/**
 * The application's single toast outlet. Centralizes react-toastify
 * configuration AND the deterministic test affordance (see ./toastTestHooks).
 *
 * Every `toast.*` call anywhere in the app renders through this one container,
 * so the `toastClassName` hook below is the single place that tags all toast
 * call sites with a stable, variant-aware test marker without touching any of
 * them. Behaviour is otherwise identical to the previous inline
 * <ToastContainer> in _app.tsx.
 */
const AppToastContainer = () => (
  <ToastContainer
    containerId={TOAST_CONTAINER_ID}
    position="top-center"
    transition={Slide}
    autoClose={5000}
    hideProgressBar
    newestOnTop={false}
    closeOnClick={false}
    rtl={false}
    pauseOnFocusLoss
    pauseOnHover
    draggable={false}
    theme="light"
    toastClassName={(context) =>
      [context?.defaultClassName, toastVariantClass(context?.type)]
        .filter(Boolean)
        .join(' ')
    }
    icon={({ type }) => {
      if (type === 'success') return <VerifyRoundIcon mode="success" />
      if (type === 'error') return <ErrorRound weight="bold" />
    }}
  />
)

export default AppToastContainer
